import swal from "sweetalert";
import axiosInstance from "../api";
import { setCartList, setSingleView } from "../../reusableSlice";


export const getAllCart = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/carts/", { params: data });
    if (response?.data) {
      dispatch(setCartList(response?.data?.response));
      return response.data.response; // ✅ return data for export usage
    } else {
      dispatch(setCartList([]));
      return { cart_list: [], pagination_meta: { pages: 1 } };
    }
  } catch (err) {
    dispatch(setCartList([]));
    return { cart_list: [], pagination_meta: { pages: 1 } };
  }
};



  export const getSingleView = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/carts/${id}`);
      console.log(response,"responsesdfssfs")
      if (response?.data) {
        dispatch(setSingleView(response?.data?.response))
      } else {
        dispatch(setSingleView([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSingleView([]))
    }
  };